export const LANGUAGES = {
   CROATIAN: 'hr',
   SIERRALEONE: 'en'
};
